import './styles.scss'
import {ITEUByMonth} from '../../../api/TEUByMonth/TEUByMonth.types'
import {IWidgetResponse} from '../../../api/Base/Base.types'
import NumberUtils from "../../../utils/number.utils";
import WidgetNivoBase from "../Widget.nivo.base";

interface Props {
    data?: IWidgetResponse<ITEUByMonth>
}

function TEUByMonth({data}: Props) {
    function getData() {
        if (data) {
            return data.data.map(d => ({date: `${d.month}/${d.year}`, teu: d.teu}));
        }
    }

    return (
        <div className="teu-by-month">
            <WidgetNivoBase.Bar
                title="TEU Per Month"
                data={getData()}
                keys={["teu"]}
                indexBy="date"
                axisLeftName="TEU"
                axisBottomName="Date (MM/YYYY)"
                axisBottomRotation={-45}
                formatValue={v => NumberUtils.toShortened(v, 2)}
                tooltip={({value, color}) => (
                    <div style={{padding: 12, color, background: "#222222", borderRadius: 10}}>
                        <strong>{NumberUtils.numberWithCommas(value)}</strong>
                    </div>
                )}
            />
        </div>
    )
}

export default TEUByMonth;